<template>
    <div class="main">
        <a-row class="container" :gutter="8">
            <a-col :span="16">
                <a-form :form="form">
                    <a-form-item label="任务标题" :label-col="{ xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ xl: {span: 21}, xxl: {span: 22} }">
                        <a-input placeholder="请输入任务标题" size="large" v-decorator="['title',{rules: [{ required: true, message: '请输入任务标题' }]}]">
                            <a-icon slot="prefix" type="form" value="title"/>
                        </a-input>
                    </a-form-item>
                    <a-form-item label="任务说明" :label-col="{ xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ xl: {span: 21}, xxl: {span: 22} }">
                        <vue-html5-editor :content="content" auto-height @change="updateData" ref="myeditor"></vue-html5-editor>
                    </a-form-item>
                    <a-form-item label="时间选择" :label-col="{ xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ xl: {span: 21}, xxl: {span: 22} }">
                        <a-range-picker @change="chooseDate" v-if="isShowDefaultDate" size="large" :value="[moment(beginTime, 'YYYY-MM-DD'), moment(endTime, 'YYYY-MM-DD')]"/>
                        <a-range-picker @change="chooseDate" v-else size="large"/>
                    </a-form-item>
                    <a-form-item label="执行人员" :label-col="{ lg: {span: 3}, xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ lg: {span: 14}, xl: {span: 9}, xxl: {span: 8} }">
                        <a-cascader size="large" :options="areaOptions" @change="onChange" :loadData="loadData" placeholder="请先选择所在部门" :changeOnSelect="true" @popupVisibleChange="getStatusOfCascader" notFoundContent="Not Found!"/> <!--:value="showSelectedDefaultDeptOptionsValue"-->
                    </a-form-item>
                    <a-form-item label="已选人员" :label-col="{ lg: {span: 3}, xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ lg: {span: 21}, xl: {span: 21}, xxl: {span: 22} }" v-if="executors.length > 0" style="margin-bottom: 0px;">
                        <div v-for="(item, index) in executors" :key="index" style="min-height: 64px;">
                            <div style="font-weight: bold;height: 34px;line-height: 34px;">
                                <a-icon type="team" style="color: #1890ff;padding-right: 6px;"/>
                                <span>{{onceChoosedDeptsInfo[item.dept_id]}}</span>
                            </div>
                            <ul>
                                <li v-for="(_item, _index) in item.reporter" :key="_index">{{_item}}</li>
                            </ul>
                        </div>
                    </a-form-item>
                    <a-form-item label="关联标引" :label-col="{ xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ xl: {span: 21}, xxl: {span: 22} }">
                        <a-button type="danger" size="default" @click="chooseTag" v-if="!choosedTagId">
                            选择标引<a-icon type="right" />
                        </a-button>
                        <a-tag closable color="#1890ff" @close="deleteTagInfo" style="height: 32px;line-height: 32px;" v-else>{{choosedTagName}}</a-tag>
                    </a-form-item>
                    <a-form-item label="紧急任务" :label-col="{ xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ xl: {span: 21}, xxl: {span: 22} }">
                        <a-switch @change='chooseUrgent' :checked="urgent"/>
                    </a-form-item>
                </a-form>
            </a-col>
        </a-row>
        <a-modal
                title="选择任务执行人员"
                centered
                v-model="isShowUsersModal"
                @ok="okToSelectAction"
                :maskClosable="false"
        >
            <a-checkbox
                    :indeterminate="indeterminate"
                    @change="onCheckAllUsersChange"
                    :checked="checkAll"
            >
                全选
            </a-checkbox>
            <a-divider />
            <div class="loading" v-show="isLoadingUsers">
                <a-spin />
            </div>
            <div v-if="!isDeptHaveUsers">暂无用户！</div>
            <a-checkbox-group v-else :options="userList" :value="choosedUsers" @change="onCheckUsersChange" />
        </a-modal>
        <footer-tool-bar>
            <a-button type="danger" @click="deleteArticle" v-show="articleId">删除</a-button>
            <a-button type="primary" @click="handleSubmit" :loading="submitingStatus">保存</a-button>
            <a-button type="primary" ghost @click="goBackToList">
                <a-icon type="left" />返回列表
            </a-button>
        </footer-tool-bar>
    </div>
</template>

<script>
    import moment from 'moment'
    import FooterToolBar from '../../components/FooterToolBar'
    export default {
        name: "AddTask",
        components:{
            FooterToolBar
        },
        beforeCreate () {
            this.form = this.$form.createForm(this);
        },
        data () {
            return {
                userInfo: '',
                content: '请输入内容',
                articleId: '',
                title: '',
                urgent: false,
                beginTime: '',
                endTime: '',
                type: 1,
                executors: [],
                form: this.$form.createForm(this),
                choosedTagId: '',
                choosedTagName: '',
                isShowDefaultDate: false,
                choosedDateValues: '',
                areaOptions: [],
                areaId: '',
                clickedParentDeptId: '',
                selectedOptions: [], // 部门选择结果
                showSelectedDefaultDeptOptionsValue: [],
                isShowUsersModal: false,
                statusOfCascader: false,
                checkAll: false,
                indeterminate: false,
                userList: [],
                choosedUsers: [],
                isDeptHaveUsers: true,
                isLoadingUsers: true,
                onceChoosedDeptsInfo: {},
                submitingStatus: false,
            }
        },
        methods: {
            moment,
            handleSubmit (e) {
                e.preventDefault();
                this.form.validateFields((err, values) => {
                    if (!err) {
                    } else {
                        return
                    }
                    if (this.content === '请输入内容' || !this.content) {
                        this.$message.error('请输入任务说明')
                        return
                    }
                    if (!this.beginTime || !this.endTime) {
                        this.$message.error('请选择开始时间或结束时间')
                        return
                    }
                    if (this.selectedOptions.length > 0 && !this.selectedOptions[this.selectedOptions.length - 1].isLeaf) {
                        if (!this.executors.length) {
                            this.$message.error('请选择用户所属子部门')
                            return
                        }
                    }
                    if (!this.executors.length) {
                        this.$message.error('请选择任务执行人员')
                        return
                    }
                    if (!this.choosedTagId) {
                        this.$message.error('请选择标引')
                        return
                    }
                    var urgent = 0
                    if (this.urgent) {
                        urgent = 1
                    }
                    this.submitingStatus = true
                    var postData = {id: this.articleId, 'title': values.title, 'remark': this.content, 'starttime': this.beginTime, 'endtime': this.endTime, 'article_type': this.type, 'tag_id': this.choosedTagId, 'executor': JSON.stringify(this.executors), 'urgent': urgent, 'user_id': this.userInfo.userid, 'adduser': this.userInfo.truename}
                    this.$http.post('api/assign/taskupdate', postData)
                        .then((res) => {
                            this.submitingStatus = false
                            if (res.data.state === 200) {
                                // 发布成功 全部置空
                                this.form.resetFields()
                                this.content = '请输入内容'
                                this.$store.commit('storeAddTaskInfo', {title: '', beginTime: '', endTime: '', content: '', executor: [], urgent: false, type: 1})
                                this.$store.commit('storeAddTaskChoosedTagInfo', {id: '', name: ''})
                                this.beginTime = ''
                                this.endTime = ''
                                this.type = 1
                                this.urgent = false
                                this.executors = []
                                this.choosedTagId = ''
                                this.choosedTagName = ''
                                this.showSelectedDefaultDeptOptionsValue = []
                                this.isShowDefaultDate = false
                                this.$message.success('发布成功')
                                setTimeout(() => {
                                    this.$router.push('/Main/Task/TaskList')
                                }, 2000)
                            }
                        })
                        .catch(() => {
                            this.submitingStatus = false
                        })
                })
            },
            updateData (content) {
                this.content = content
            },
            deleteArticle () {
                const that = this
                this.$confirm({
                    title: '确定删除该报题?',
                    content: '',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '取消',
                    centered: true,
                    onOk() {
                        that.deleting()
                    },
                    onCancel() {
                    },
                });
            },
            deleting () {
                this.$http.post('api/report/delete', {ids: this.articleId})
                    .then((res) => {
                        if (res.data.state === 200) {
                            this.$message.success('已删除')
                            setTimeout(() => {
                                this.$router.go(-1)
                            }, 2000)
                        }
                    })
                    .catch(() => {
                    })
            },
            goBackToList () {
                this.$router.push('/Main/Task/TaskList')
            },
            chooseDate(date, dateString) {
                this.beginTime = dateString[0]
                this.endTime = dateString[1]
            },
            chooseUrgent (checked) {
                this.urgent = checked
            },
            chooseTag () {
                if (this.form.getFieldValue('title')) {
                    this.title = this.form.getFieldValue('title')
                }
                this.$store.commit('storeIsSelectingTagAction', true)

                this.$store.commit('storeAddTaskInfo', {title: this.title, beginTime: this.beginTime, endTime: this.endTime, content: this.content, executor: this.executors, urgent: this.urgent, type: this.type, selectedOptions: this.selectedOptions})
                this.$router.push('/Main/Task/TagList')
            },
            deleteTagInfo () {
                this.choosedTagId = ''
                this.choosedTagName = ''
                this.$store.commit('storeAddTaskChoosedTagInfo', {id: '', name: ''})
            },
            getAreaList () {
                this.$http.post('api/ucenter/arealist')
                    .then((res) => {
                        if (res.data.state === 200) {
                            if (res.data.data.length > 0) {
                                for (var i in res.data.data) {
                                    this.areaOptions.push({value: res.data.data[i].id, label: res.data.data[i].areaname, isLeaf: false})
                                }
                                this.$store.commit('storeAreaList', this.areaOptions)
                            }
                        }
                    })
                    .catch(() => {
                    })
            },
            getUserList (deptId) {
                const that = this
                that.isDeptHaveUsers = true
                that.isLoadingUsers = true
                that.userList = []
                that.choosedUsers = []
                that.indeterminate = false
                that.checkAll = false
                that.$http.post('api/ucenter/userlist', {'limit': 100, 'area_id': this.areaId, 'dept_id': deptId})
                    .then((res) => {
                        this.isLoadingUsers = false
                        if (res.data.state === 200) {
                            for (var i in res.data.data) {
                                this.userList.push({label: res.data.data[i].truename, value: res.data.data[i].truename})
                            }
                        } else if (res.data.state === 404) {
                            that.isDeptHaveUsers = false
                        }
                    })
                    .catch(() => {
                        this.isLoadingUsers = false
                    })
            },
            getDeptList (targetOption) {
                const that = this
                that.$http.post('api/ucenter/deptlist', {'limit': 100, 'area_id': this.areaId})
                    .then((res) => {
                        targetOption.loading = false;
                        if (res.data.state === 200) {
                            targetOption.children = []
                            var isHaveDepts = false
                            for (var k in res.data.data) {
                                if (parseInt(res.data.data[k].parentid) === 0) {
                                    isHaveDepts = true
                                    break
                                }
                            }

                            for (var i in res.data.data) {
                                if (isHaveDepts) { // 区域管理员和超级管理员
                                    if (parseInt(res.data.data[i].parentid) === 0) {
                                        var eachDeptIsHaveSon = false
                                        for (var j in res.data.data) {
                                            if (parseInt(res.data.data[i].id) === parseInt(res.data.data[j].parentid)) {
                                                eachDeptIsHaveSon = true
                                                break
                                            }
                                        }
                                        if (eachDeptIsHaveSon) {
                                            targetOption.children.push( {
                                                value: res.data.data[i].id,
                                                label: res.data.data[i].deptname,
                                                isLeaf: false
                                            })
                                        } else {
                                            targetOption.children.push( {
                                                value: res.data.data[i].id,
                                                label: res.data.data[i].deptname,
                                                isLeaf: true
                                            })
                                        }
                                    }
                                } else { // 部门管理员
                                    targetOption.children.push( {
                                        value: res.data.data[i].id,
                                        label: res.data.data[i].deptname,
                                        isLeaf: true
                                    })
                                }
                            }
                            this.areaOptions = [...this.areaOptions]
                            that.$store.commit('storeDeptList', res.data.data)
                        }
                    })
                    .catch(() => {
                    })
            },
            getSecondDept (parentid, targetOption) {
                var currrentAreaDepts = this.$store.state.deptList
                targetOption.loading = false;
                var isHaveSon = false
                for (var i in currrentAreaDepts) {
                    if (parseInt(currrentAreaDepts[i].parentid) === parseInt(parentid)) {
                        isHaveSon = true
                        break
                    }
                }
                if (isHaveSon) {
                    targetOption.children = []
                    for (var i in currrentAreaDepts) {
                        if (parseInt(currrentAreaDepts[i].parentid) === parseInt(parentid)) {
                            targetOption.children.push( {
                                value: currrentAreaDepts[i].id,
                                label: currrentAreaDepts[i].deptname,
                                isLeaf: true,
                            })
                        }
                    }
                    this.areaOptions = [...this.areaOptions]
                } else {
                    targetOption.isLeaf = true
                }
            },
            // 选择任务执行人
            onChange(value, selectedOptions) {
                this.areaId = value[0]
                if (value[1]) {
                    this.clickedParentDeptId = value[1]
                } else {
                    this.clickedParentDeptId = ''
                }
                if (!selectedOptions) {
                    this.selectedOptions = []
                } else {
                    this.selectedOptions = selectedOptions
                }
            },
            loadData(selectedOptions) {
                const targetOption = selectedOptions[selectedOptions.length - 1];
                targetOption.loading = true;
                if (!this.clickedParentDeptId) {
                    this.getDeptList(targetOption)
                } else {
                    this.getSecondDept(this.clickedParentDeptId, targetOption)
                }
            },
            getStatusOfCascader (value) {
                this.statusOfCascader = value
                if (!this.selectedOptions.length) {
                } else {
                    if (!this.statusOfCascader) {
                        if (this.clickedParentDeptId) {
                            if (!this.selectedOptions[this.selectedOptions.length - 1].isLeaf) {
                                this.$message.error('请选择用户所属子部门')
                            } else {
                                this.isShowUsersModal = true
                            }
                        }
                    }
                }
            },
            onCheckAllUsersChange (e) {
                if (this.userList.length > 0) {
                    if (e.target.checked) {
                        this.indeterminate = false
                        this.checkAll = true
                        for (var i in this.userList) {
                            this.choosedUsers.push(this.userList[i].value)
                        }
                    } else {
                        this.checkAll = false
                        this.choosedUsers = []
                    }
                } else {
                    this.checkAll = false
                }
            },
            onCheckUsersChange (checkedValue) {
                this.choosedUsers = checkedValue
                if (this.choosedUsers.length < this.userList.length) {
                    if (this.choosedUsers.length === 0) {
                        this.indeterminate = false
                        this.checkAll = false
                    } else {
                        this.indeterminate = true
                        this.checkAll = false
                    }
                } else {
                    this.indeterminate = false
                    this.checkAll = true
                }
            },
            okToSelectAction () {
                this.isShowUsersModal = false
                if (this.choosedUsers.length > 0) {
                    var isHaveDeptIdInList = false
                    var index = -1
                    var deptId = this.selectedOptions[this.selectedOptions.length - 1].value
                    for (var i in this.executors) {
                        if (this.executors[i].dept_id === deptId) {
                            isHaveDeptIdInList = true
                            index = i
                            break
                        }
                    }
                    if (isHaveDeptIdInList) {
                        this.executors[index].reporter = this.choosedUsers
                    } else {
                        this.executors.push({dept_id: deptId, reporter: this.choosedUsers})
                        var allDeptName = ''
                        for (var i in this.selectedOptions) {
                            if (i == 0) {
                                allDeptName += this.selectedOptions[i].label
                            } else {
                                allDeptName = allDeptName + ' / ' + this.selectedOptions[i].label
                            }
                        }
                        this.onceChoosedDeptsInfo[deptId] = allDeptName
                        this.$store.commit('storeOnceChoosedDeptsInfo', this.onceChoosedDeptsInfo)
                    }
                }
            }
        },
        watch: {
            isShowUsersModal (newValue, oldValue) {
                // 选择执行人模态窗口打开
                if (newValue) {
                    this.getUserList(this.selectedOptions[this.selectedOptions.length - 1].value)
                }
            }
        },
        created () {
            this.userInfo = JSON.parse(localStorage.getItem('siteinfo'))
        },
        mounted () {
            this.choosedTagId = this.$store.state.addTaskChoosedTagInfo.id
            this.choosedTagName = this.$commonFunction.mySubStr(this.$store.state.addTaskChoosedTagInfo.name, 60)
            this.title = this.$store.state.addTaskInfo.title
            this.form.setFieldsValue({title: this.title})
            this.beginTime = this.$store.state.addTaskInfo.beginTime
            this.endTime = this.$store.state.addTaskInfo.endTime
            this.content = this.$store.state.addTaskInfo.content
            this.type = this.$store.state.addTaskInfo.type
            this.executors = this.$store.state.addTaskInfo.executor

            this.urgent = this.$store.state.addTaskInfo.urgent

            this.selectedOptions = this.$store.state.addTaskInfo.selectedOptions
            // if (this.selectedOptions.length > 0) {
            //     for (var i in this.selectedOptions) {
            //         this.showSelectedDefaultDeptOptionsValue.push(this.selectedOptions[i].value)
            //     }
            // }
            this.onceChoosedDeptsInfo = this.$store.state.onceChoosedDeptsInfo
            if (!this.beginTime || !this.endTime) {
                this.isShowDefaultDate = false
            } else {
                this.isShowDefaultDate = true
            }
            // 获取区域列表
            if (this.$store.state.areaList.length === 0) {
                this.getAreaList()
            } else {
                this.areaOptions = this.$store.state.areaList
            }
        }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 42px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        background-color: #fff;
        padding-left:10px;
    }
    .container{
        margin-top: 20px;
        margin-bottom: 56px;
    }
    ul{
        margin-left: 20px;
    }
    ul li{
        float: left;
        min-width: 60px;
        height: 30px;
        line-height: 30px;
    }
    .loading {
        text-align: center;
        border-radius: 4px;
        padding: 10px 50px;
    }
    .ant-checkbox-group >>> .ant-checkbox-group-item{
        margin-bottom: 8px!important;
    }
</style>
